class TransferToUserBalanceReq {
  constructor() {
    this.packageId = undefined;
    this.userId = undefined;
  }
}
export default TransferToUserBalanceReq;
